import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ShipmentDetailsComponent } from "../dashboardModals/shipment-details/shipment-details.component";
import { StorageService } from "../storage.service";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpService } from "../http.service";
import { DateTime } from "luxon";
// import { _ } from "underscore";
import * as _ from 'underscore';
import { ValidationService } from "../validation.service";
import { SnackbarService } from "../snackbar.service";
import { EventService } from "../event.service";
import { Subscription } from "rxjs";
import { TimeService } from "../time.service";
import { ConfirmationModalComponent } from "../confirmation-modal/confirmation-modal.component";
import { MatAutocompleteTrigger } from "@angular/material";
import { Messages } from "../constants/messages";
import { TranslateService } from "@ngx-translate/core";
import { ViewLtlOrdersComponent } from "../view-ltl-orders/view-ltl-orders.component"
import {
  trigger,
  state,
  transition,
  style,
  animate,
  sequence,
} from "@angular/animations";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";


export interface Orders {
  _id: string;
  OIN: string;
  pickDate: string;
  from: Array<any>;
  to: Array<any>;
  allocation: string;
  vehicle: string;
  materials: Array<any>;
  organization: object;
  status: string;
  totalShipments: number;
}
export const rowsAnimation = trigger("rowsAnimation", [
  transition("void => *", [
    style({
      height: "*",
      opacity: "0",
      transform: "translateX(-550px)",
      "box-shadow": "none",
    }),
    sequence([
      animate(
        ".05s ease",
        style({
          height: "*",
          opacity: ".2",
          transform: "translateX(0)",
          "box-shadow": "none",
        })
      ),
      animate(
        ".35s ease",
        style({ height: "*", opacity: 1, transform: "translateX(0)" })
      ),
    ]),
  ]),
]);
@Component({
  selector: 'app-ltl-orders',
  templateUrl: './ltl-orders.component.html',
  styleUrls: ['./ltl-orders.component.scss'],
  animations: [
    rowsAnimation,
    trigger("filterFade", [
      state(
        "open",
        style({
          opacity: 1,
          height: "auto",
          padding: "5px",
          backgroundColor: "#f7faff",
        })
      ),
      state(
        "closed",
        style({
          opacity: 0,
          height: "0px",
        })
      ),
      transition("open => closed", [animate("0.3s")]),
      transition("closed => open", [animate("0.4s")]),
    ]),
  ],
})

export class LtlOrdersComponent implements OnInit {

  dataSource: MatTableDataSource<Orders>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('filtersDialog', { static: true }) filtersDialog: TemplateRef<any>;
  @ViewChild('viewEpod', { static: true }) viewEpodDialog: TemplateRef<any>;
  @ViewChild("uploadDocs", { static: true }) uploadDocs: TemplateRef<any>;
  @ViewChild('reportDialog', { static: true }) reportDialog: TemplateRef<any>;



  filter: any;
  vehicleFromDate: any;
  vehicleToDate: any;
  AdvacnceFilterList = [];
  date_filter: any = {
    from: {
      date: new Date()
    },
    to: {
      date: new Date()
    }
  }
  LtlFromDate: any;
  LtlToDate: any;
  ordersArray: any;
  totalOrders: any;
  orders: any[];
  sort: MatSort;
  filtersDialogRef: any;
  statusArray = [
    {
      status: "Active",
      is_deleted: false,
    },
    {
      status: "Deleted",
      is_deleted: true,
    },
  ];
  selectedStatus: any;
  showLoader = false;
  filterRefnumber = "";
  uploadDocsRef: any;
  filterIncoicenumber = "";
  filterOrderStatus = "";
  selectedOrderData: any = {};
  dashboardFilters: any = {
    orderIds: [],
    from: [],
    to: [],
    is_deleted: false,
    fromPickupDate: "",
    toPickupDate: "",
    created_at: "",
    materials: [],
    organizations: [],
    ref_number: "",
    invoice_no: "",
    status: "",
    limit: 0,
    skip: 0,
    is_all_unit: false,
  };
  dashboardFilterChips = [];
  displayedColumns: string[] = [
    "order",
    "invoiceNumber",
    "AWBNumbers",
    'pickupDate',
    "from",
    "to",
    "allocation",
    // "organization",
    "cases",
    "verificationDate_Status",
    "EpodReceivedDate",
    "epod",
    "actions",
  ];
  epod: any;
  previewRef: any;
  epods_data: any = new FormData();
  reportDialogRef: any;
  orderId: string;
  delivery_date: Date = new Date();
  epod_date: any = new FormData();
  reportFromDate: any = '';
  reportToDate: any = '';
  reportStatus = '';
  selectedDeliveryStatus = "";
  selectedEpodStatus = "";
  selectedServiceProvider = "";
  files: any[];
  productName: string;
  brand: string;
  numBoxes: string;
  referenceNumber: string;
  quantity: string;
  value: string;
  order_id: any;
  rejectionHeaderName: any;
  rejectionUploadDialogRef: any;
  damageShortageType: any;
  formData: FormData;
  showStatusTab: any;




  constructor(
    private dialog: MatDialog,
    private storage: StorageService,
    private route: Router,
    private http: HttpService,
    private valid: ValidationService,
    private snackBar: SnackbarService,
    private timeService: TimeService,
    private events: EventService,
    private actRoute: ActivatedRoute,
    private translation: TranslateService,
  ) { }


  ngOnInit() {
    this.selectedStatus = this.statusArray[0];
    this.getOrders();
  }
  getOrders(filters: any = {}) {
    this.showLoader = true;
    filters.limit = this.paginator.pageSize || 25;
    filters.skip =
      this.paginator.pageIndex * (this.paginator.pageSize || filters.limit);
    filters.is_deleted = this.selectedStatus.is_deleted;
    if (this.filterRefnumber && this.filterRefnumber.length > 2) {
      filters.ref_number = this.filterRefnumber.toString()
    } else if (filters['ref_number'] === '') {
      console.log("true");
      delete filters['ref_number'];
    }
    if (this.filterIncoicenumber && this.filterIncoicenumber.length > 2) {
      filters.invoice_no = this.filterIncoicenumber.toString()
    } else if (filters['invoice_no'] === '') {
      console.log("true");
      delete filters['invoice_no'];
    }

    if (this.filter) {
      filters.dashboard_filter = this.filter;
    }
    if (this.vehicleFromDate && this.vehicleToDate) {
      filters.fromPickupDate = DateTime.fromJSDate(this.vehicleFromDate).toFormat('yyyy-MM-dd');
      filters.toPickupDate = DateTime.fromJSDate(this.vehicleToDate).toFormat('yyyy-MM-dd');
    }
    if (this.LtlFromDate && this.LtlToDate) {
      // filters.from=DateTime.fromJSDate(this.LtlFromDate).toFormat('yyyy-MM-dd');
      // filters.to=DateTime.fromJSDate(this.LtlToDate).toFormat('yyyy-MM-dd');
    }

    this.http.post("v1/orderLTL/getMany", filters).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.ordersArray = data.data.orders;
          this.totalOrders = data.data.count;
          this.orders = [];
          this.ordersArray.forEach((element) => {
            const now: any = DateTime.local();
            const deadline: any = this.timeService.IsoToUTC(
              element.assignment_deadline
            );

            if (!element.OIN) {
              return;
            }
            const temp: any = {};
            temp._id = element._id;
            temp.order = element.OIN;
            temp.consigneeName = element.consignee_name;
            temp.shipmentDate = this.timeService.toShortDateTime(
              element.created_at
            );
            temp.pickDate = this.timeService.toShortDateTime(
              element.pickup_date
            );
            temp.deadline = this.checkDeadline(element.pickup_date);
            temp.from = element.pickup_locations;
            temp.assignment_deadline = element.assignment_deadline
              ? this.timeService.toShortDateMonthTime(
                element.assignment_deadline
              )
              : "";
            // temp.dropDate = DateTime.fromISO(element.delivery_date.given).toLocaleString(DateTime.DATETIME_SHORT); //removed in the orders table
            temp.to = element.delivery_locations;
            temp.assigned = element.assigned || 0;
            temp.accepted = element.accepted || 0;
            temp.allocated = element.allocated || (element.service_provider ? true : false)
            temp.pending = (!element.service_provider ? true : false);
            temp.status = element.status ? element.status : 'N/A';
            temp.requested = element.req_no_of_vehicles;
            temp.to_be_allocated = element.to_be_allocated || 0;
            temp.fulfilled = element.fulfilled || 0;
            temp.cancelled = element.cancelled;
            temp.weight = element.weight || 0;
            temp.docs = element.doc_urls || [];
            temp.comments = element.comments ? element.comments : "";
            temp.no_of_packages = element.no_of_packages || 0;
            temp.cbm_value = element.cbm_value || 0;
            temp.purchase_order = element.purchase_order || "";
            temp.uom = element.uom || '';
            temp.reference = element.winner ? (element.winner.erp_reference.length ? element.winner.erp_reference[0].reference_id + ' - ' : '') : '';
            temp.driver_accepted = element.driver_accepted ? element.driver_accepted : 0;
            temp.materials = element.materials;
            temp.organization = element.organization;
            temp.to_be_allocated = element.to_be_allocated;
            temp.cancelled = element.canceled;
            temp.is_disabled = element.is_disabled;
            temp.eway_bill_no = element.eway_bill_no;
            temp.others = element.others ? element.others : "";
            temp.invoice_no = element.others ? element.others.invoice_no : "";
            temp.verification_status = element.epod_data ? element.epod_data.verification_status : "";
            temp.verification_date = element.epod_data ? (element.epod_data.verification_date) : "";
            temp.EpodReceivedDate = element.epod && element.epod_data && (element.epod_data.date) ? (element.epod_data.date) : (element.epod && element.delivery_date ? element.delivery_date : "--");
            // if(element.delivery_date){
            //   temp.EpodReceivedDate = element.delivery_date || "--";
            // }else if(element.epod_data) {
            //   temp.EpodReceivedDate = element.epod_data.date || "--";
            // }else {
            //   temp.EpodReceivedDate = "--"
            // }
            temp.ref_numbers = element.ref_number;
            temp.epod = element.epod ? element.epod : null;
            temp.epodType = element.epod ? element.epod.split('.').pop() : null;
            temp.box = element.box ? element.box : [];
            temp.service_providers = element.service_provider;
            temp.delete_reason = element.delete_reason
              ? element.delete_reason
              : "--";
            temp.epod_date = element.epod_date;
            temp.epod_approved = element.epod_approved;
            temp.epod_rejection_reason = element.epod_rejection_reason;
            temp.epod_approved_by = element.epod_approved_by;
            temp.epod_data = element.epod_data;
            // temp.epod_data = element.epod_data;
            temp.invoice_date = element.others ? element.others.invoice_date : "";
            temp.cft_wt = element.others ? element.others.cft_wt : "";
            temp.lr_date = element.others ? element.others.lr_date : "";
            temp.ps_date = element.others ? element.others.ps_date : "";
            temp.ps_num = element.others ? element.others.ps_num : "";
            temp.consignee_name = element.consignee_name ? element.consignee_name : "";
            //// Status
            if (element.status === "PNDG") {
              temp.status = "Pending";
            } else if (element.status === "ALC") {
              temp.status = "Allocated";
            } else if (element.status === "ACPT") {
              temp.status = "Accepted";
            } else if (element.status === "ASN") {
              temp.status = "Assigned";
            } else if (element.status === "ITNS") {
              temp.status = "In Transit";
            } else if (element.status === "CPTD") {
              temp.status = "Completed";
            } else if (element.status === "CNCL") {
              temp.status = "Cancelled";
            }
            temp.activity_timeline = element.activity_timeline ? element.activity_timeline : []
            ///// End
            temp.enableEdit = element.allocated;
            this.orders.push(temp);
          });
          if (Object.keys(this.selectedOrderData).length !== 0) {
            const newOrderData = this.orders.filter((e: any) => {
              return e.order == this.selectedOrderData.order;
            });
            if (newOrderData.length) {
              this.selectedOrderData = newOrderData[0];
              this.getOrderStatus(this.selectedOrderData);
            }
          }
          this.showLoader = false;
          console.log("🚀 ~ file: ltl-orders.component.ts:314 ~ LtlOrdersComponent ~ this.ordersArray.forEach ~ this.orders:", this.orders);
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.orders);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant(
              "DASHBOARD.pagination_label"
            );
            console.log("🚀 ~ file: ltl-orders.component.ts:327 ~ LtlOrdersComponent ~ getOrders ~ this.dataSource:", this.dataSource)

          } else {
            this.dataSource = new MatTableDataSource(this.orders);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant(
              "DASHBOARD.pagination_label"
            );
          }

          if (this.filtersDialogRef)
            this.filtersDialogRef.close();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
        this.paginator._intl.itemsPerPageLabel = this.translation.instant(
          "DASHBOARD.pagination_label"
        );
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }
  checkDeadline(pickup_date: any): any {

  }
  getOrderStatus(selectedOrderData: any) {

  }

  openBulkUpload() {
  }
  openBulkLRUpload() {

  }
  refreshDashboard() {

  }
  openUploadDocs(element) {

    this.delivery_date = new Date();
    this.epod_date = new Date();
    this.epods_data = new FormData();
    console.log("🚀 ~ file: ltl-orders.component.ts:413 ~ LtlOrdersComponent ~ openUploadDocs ~ this.epods_data:", this.epods_data)

    this.orderId = element._id;
    this.uploadDocsRef = this.dialog.open(this.uploadDocs, {

    });
  }
  openFilterDialog() {
    this.vehicleFromDate = '';
    this.vehicleToDate = '';
    this.dashboardFilters['ref_number'] = '';
    this.dashboardFilters['status'] = '';
    this.dashboardFilters['service_provider'] = '';
    this.dashboardFilters['epod'] = '';
    this.dashboardFilters['invoice_no'] = '';


    this.filtersDialogRef = this.dialog.open(this.filtersDialog);
  }
  addAdvanceFilter(value: any, type: string = "status") {
    console.log("Correct console:", "values came", value);
    switch (type) {
      case "awb":
        this.dashboardFilters['ref_number'] = value;
        break;
      case "invoice":
        this.dashboardFilters['invoice_no'] = value;
        break;
      case "status":
        this.dashboardFilters['status'] = value;
        // this.showSelectMenu('orderStatus');
        break;
      case "from":
        const from_date = value;
        console.log("from", new Date(value));
        this.dashboardFilters.fromPickupDate = from_date.toString();

        break;
      case "to":
        const to_date = value;
        console.log("to", new Date(value));
        this.dashboardFilters.toPickupDate = to_date.toString()
        break;
      case "serviceProvider":
        this.dashboardFilters['service_provider'] = value;
        // this.showSelectMenu('service_provider');
        break;
      case "epod":
        this.dashboardFilters['epod'] = value;
      //  this.AdvacnceFilterList.push({ name: 'Epod State', value: value });
      // this.showSelectMenu('epod');

      default:
        break;
    }
  }
  clear() {
    this.vehicleToDate = '',
      this.vehicleFromDate = '',
      this.dashboardFilters = {
        orderIds: [],
        from: [],
        to: [],
        is_deleted: false,
        fromPickupDate: "",
        toPickupDate: "",
        created_at: "",
        materials: [],
        organizations: [],
        ref_number: "",
        invoice_no: "",
        status: "",
        limit: 0,
        skip: 0,
        is_all_unit: this.dashboardFilters.is_all_unit,
      }
    this.date_filter.date = new Date();
    this.AdvacnceFilterList = [];
    // this.getOrders(this.dashboardFilters);
  }
  submitSearch() {
    console.log(this.dashboardFilters);
    this.AdvacnceFilterList = [];

    if (this.dashboardFilters['ref_number']) {
      this.AdvacnceFilterList.push({ name: 'AWB Number', value: this.dashboardFilters['ref_number'] });
    }
    if (this.dashboardFilters['invoice_no']) {
      this.AdvacnceFilterList.push({ name: 'Invoice Number', value: this.dashboardFilters['invoice_no'] });
    }
    if (this.dashboardFilters['status']) {
      this.AdvacnceFilterList.push({ name: 'Order Status', value: this.dashboardFilters['status'] });
    }
    if (this.vehicleFromDate) {
      this.AdvacnceFilterList.push({ name: 'Pickup Date From', value: DateTime.fromJSDate(this.vehicleFromDate).toFormat('dd-MMM-yyyy') });
    }
    if (this.vehicleToDate) {
      this.AdvacnceFilterList.push({ name: 'Pickup Date To', value: DateTime.fromJSDate(this.vehicleToDate).toFormat('dd-MMM-yyyy') });
    }
    if (this.dashboardFilters['service_provider']) {
      this.AdvacnceFilterList.push({ name: 'Service Provider', value: this.dashboardFilters['service_provider'] });
    }
    if (this.dashboardFilters['epod']) {
      this.AdvacnceFilterList.push({ name: 'Epod State', value: this.dashboardFilters['epod'] });
    }



    this.getOrders(this.dashboardFilters);
  }
  viewOrderDetails(order) {
    const viewDialog = this.dialog.open(ViewLtlOrdersComponent, {
      data: order,
    });
    viewDialog.afterClosed().subscribe((data: any) => {
      if (data && data.statusCode == 200) {
        this.getOrders();
      }
    })
  }
  showPreview(element) {
    this.previewRef = this.dialog.open(this.viewEpodDialog);
    this.epod = element.epod;
  }
  deleteEpod(element) {
    this.showLoader = true;
    this.http.post('v1/orderLTL/delete_epod', { order_id: element._id }).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.showLoader = false;
        this.getOrders(this.dashboardFilters);
        this.snackBar.openSnackBar(this.translation.instant('Epod Deleted Successfully'));
      }
    },
      (err) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  fileChanged(event: any, type: any) {
    this.epods_data = new FormData();
    this.epods_data.append('epod', event.target.files[0], event.target.files[0].name);
  }

  UploadEpod(event: any, type: any) {

    this.epods_data.append('delivery_date', DateTime.fromJSDate(this.delivery_date).startOf("day").toUTC());
    this.epods_data.append('epod_date', DateTime.fromJSDate(this.epod_date).startOf("day").toUTC());
    this.showLoader = true;
    console.log("🚀 ~ file: ltl-orders.component.ts:556 ~ LtlOrdersComponent ~ fileChanged ~ this.epods_data:", this.epods_data)
    this.http.upload('v1/orderLTL/upload_epod/' + this.orderId, this.epods_data).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.showLoader = false;
        this.uploadDocsRef.close();
        this.getOrders(this.dashboardFilters);
        this.snackBar.openSnackBar(this.translation.instant('Epod Uplaoded Successfully'));
      }
    },
      (err) => {
        this.epods_data = new FormData();
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );

  }
  openReportDialog() {
    this.clearReportDialog();
    this.reportDialogRef = this.dialog.open(this.reportDialog);
  }
  clearReportDialog() {

    this.reportFromDate = '';
    this.reportToDate = '';
    this.selectedDeliveryStatus = "";
    this.selectedEpodStatus = "";
    this.selectedServiceProvider = "";

  }
  generateReport() {
    let url = "ltl_report";
    let request: any = {};
    if (this.reportFromDate && this.reportToDate) {
      let from: any = DateTime.fromJSDate(this.reportFromDate).startOf("day").toUTC();
      let to: any = DateTime.fromJSDate(this.reportToDate).endOf("day").toUTC();
      request.from = from.ts;
      request.to = to.ts;

      if (!!this.selectedServiceProvider) {
        request.service_provider = this.selectedServiceProvider;
      }

      if (!!this.selectedDeliveryStatus) {
        request.status = this.selectedDeliveryStatus;
      }

      if (!!this.selectedEpodStatus) {
        request.epod = this.selectedEpodStatus;
      }


      this.http.post("v1/reports/" + url, request, 2).subscribe(
        (response: any) => {
          window.open(response.data.link, "_blank");

          if (this.filtersDialogRef)
            this.filtersDialogRef.close();
          this.reportDialogRef.close();
        },
        (err: any) => {
          this.snackBar.openSnackBar(err.error.message, "", "err");
        }
      );
    } else {
      this.snackBar.openSnackBar('from and to date mandatory', "", "err");
    }

  }
  changeOrder() {
    this.route.navigateByUrl('dashboard');
  }
  pageNavigate(event: PageEvent) {
    this.dashboardFilters.limit = event.pageSize;
    this.dashboardFilters.skip = event.pageIndex * event.pageSize;
    this.dashboardFilters.is_deleted = this.selectedStatus.is_deleted;
    this.getOrders(this.dashboardFilters);
  }
}

